import script from "./ScrollableSessions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollableSessions.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollableSessions.vue?vue&type=style&index=0&id=16afc106&lang=css"

const __exports__ = script;

export default __exports__